/**
 * Persists supplier CRM UI choices (layout, grouping, collapsed sections) in localStorage.
 * Cookies are not used: no server round-trips, larger quota, simpler for client-only state.
 */

const STORAGE_KEY = 'idotooSupplierCrmUi';

const defaults = () => ({
  groupBy: 'stage',
  layout: 'list',
  collapsedStageSlugs: []
});

export function loadCrmPreferences() {
  try {
    if (typeof localStorage === 'undefined') return defaults();
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return defaults();
    const parsed = JSON.parse(raw);
    const collapsed = Array.isArray(parsed.collapsedStageSlugs)
      ? parsed.collapsedStageSlugs.filter((s) => typeof s === 'string')
      : [];
    return { ...defaults(), ...parsed, collapsedStageSlugs: collapsed };
  } catch {
    return defaults();
  }
}

/**
 * @param {Partial<{ groupBy: string, layout: string, collapsedStageSlugs: string[] }>} partial
 */
export function saveCrmPreferencesMerge(partial) {
  try {
    if (typeof localStorage === 'undefined') return;
    const current = loadCrmPreferences();
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...current, ...partial }));
  } catch {
    // Quota or private mode — ignore
  }
}
